import { Component } from '@theme/component';

/**
 * @typedef {object} CushionInsertToggleRefs
 * @property {HTMLInputElement} checkbox
 */

/**
 * Swaps the add-to-cart target between this product's own bundle variant
 * and its Cover product's variant, based on the checkbox state. Deliberately
 * does not dispatch `variant:selected`/`variant:update` — this product has
 * no variants to select, and those events assume a fetched-HTML payload
 * (see `assets/product-form.js` / `assets/sticky-add-to-cart.js`) that
 * doesn't exist here. Instead it writes directly to the concrete DOM that
 * add-to-cart and the price display actually read.
 *
 * @extends Component<CushionInsertToggleRefs>
 */
export default class CushionInsertToggle extends Component {
  handleToggle() {
    const checked = this.refs.checkbox.checked;
    const variantId = checked ? this.dataset.coverVariantId : this.dataset.bundleVariantId;
    const price = checked ? this.dataset.coverPrice : this.dataset.bundlePrice;
    const productId = this.dataset.productId;

    // This product can have more than one product-form-component / product-price
    // on the page (e.g. a static quantity-only buy-buttons block alongside the
    // real one), so every instance for this product needs updating, not just
    // the first match.
    const forms = document.querySelectorAll(`product-form-component[data-product-id="${productId}"]`);
    for (const form of forms) {
      const variantIdInput = /** @type {HTMLInputElement | null} */ (form.querySelector('input[name="id"]'));
      if (variantIdInput) variantIdInput.value = variantId ?? '';
    }

    const priceBlocks = document.querySelectorAll(`product-price[data-product-id="${productId}"] [ref="priceContainer"] .price`);
    for (const priceEl of priceBlocks) {
      priceEl.textContent = price ?? '';
    }

    if (variantId) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }

    const stickyAddToCart = document.querySelector('sticky-add-to-cart');
    if (stickyAddToCart instanceof HTMLElement) {
      stickyAddToCart.dataset.currentVariantId = variantId;
      const stickyPriceEl = stickyAddToCart.querySelector('.price');
      if (stickyPriceEl) stickyPriceEl.textContent = price ?? '';
    }
  }
}

customElements.define('cushion-insert-toggle', CushionInsertToggle);
